import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import { createPortal } from 'react-dom';
import { useOutletContext } from './OutletContext';

interface OutletInjectProps {
  id?: string;
  children: React.ReactNode;
  asChild?: boolean;
}

export function OutletInject({ id, children, asChild }: OutletInjectProps) {
  const { getOutlet } = useOutletContext();
  const outlet = getOutlet(id);

  if (!outlet?.current) {
    return null;
  }

  const content = asChild ? <Slot>{children}</Slot> : children;

  return createPortal(content, outlet.current);
}
